import { UserPermissions } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import Icon from 'Icons/NavigationItem/Company';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements';

const LazyLandingPageSettings = React.lazy(() => import('./Pages'));

const insuranceSettingsConfiguration: FeatureConfiguration = {
    name: 'administrationFeature:system.landingPage.title',
    navigationItem: {
        route: {
            text: 'administrationFeature:sidebar.system.landingPage.title',
            url: '/landing-page-settings',
            Icon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyLandingPageSettings />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        isGloballyAccessible: false,
        permissions: [UserPermissions.ManageAdminConfig],
    },
    disableFeature: [],
};

export default insuranceSettingsConfiguration;
